<template>
  <page layoutClass="referral-requests" :loading="!requestedReferrals">
    <template v-if="requestedReferrals && requestedReferrals.total">
      <h2>{{ $t('referrals.referral-requests-title') }}</h2>
      <job-referrals-container layout="page" :results="requestedReferrals" @finished="finishedReferralRequest"/>
    </template>
    <div v-else class="mt-3 text-center">
      <h3>{{ $t('referrals.errors.no-outstanding-requests') }}</h3>
      <p>{{ $t('referrals.errors.no-outstanding-requests-description') }}</p>
      <b-img fluid src="/static/images/illustrations/1.svg"/>
    </div>
  </page>
</template>

<script>
import Page from '@/components/Page';
import JobReferralsContainer from '@/components/job-referrals/container';
import ReferralsEmployeeRequestsQuery from '@/graphql/queries/ReferralsEmployeeRequests.gql';

export default {
  components: {
    Page,
    JobReferralsContainer,
  },
  data: () => ({
    err: null,
  }),
  apollo: {
    requestedReferrals: {
      query: ReferralsEmployeeRequestsQuery,
      variables: { page: 1, limit: 12 },
      update: ({ user: { requested } }) => requested,
      error(err) {
        this.err = `${err}`;
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  },
  metaInfo() {
    const meta = {
      title: this.$t('referrals.referral-requests-title'),
    };

    if (this.requestedReferrals && this.requestedReferrals.entries && this.requestedReferrals.entries.length) {
      meta.title = `${meta.title} (${this.requestedReferrals.entries.length})`;
    }

    return meta;
  },
  methods: {
    finishedReferralRequest({ referralID }) {
      try {
        const client = this.$apollo.getClient();

        // Fetch query & variables from the Apollo definition above, D-R-Y!
        const { query, variables } = this.$options.apollo.requestedReferrals;

        const data = client.readQuery({ query, variables });

        if (data && data.user && data.user.requested && data.user.requested.edges) {
          data.user.requested.edges = data.user.requested.edges.filter(({ entry: { id } }) => id !== referralID);
          data.user.requested.total--;
        }

        client.writeQuery({ query, variables, data });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/variables';
.page .referral-requests {
  .row.title {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  p {
    font-size: $small-font-size;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/users/ReferralRequests.vue